import React from "react";

// * Styles
import {
  Container,
  InfoSec,
  InfoRow,
  InfoColumn,
  TextWrapper,
  Heading,
  Subtitle,
  ImgWrapper,
  Img,
} from "./Info.elements";

function landing({ imgStart, headline, description, start, img, alt }) {
  return (
    <InfoSec>
      <Container>
        <InfoRow imgStart={imgStart}>
          <InfoColumn>
            <TextWrapper>
              <Heading>{headline}</Heading>
              <Subtitle>{description}</Subtitle>
            </TextWrapper>
          </InfoColumn>
          <InfoColumn>
            <ImgWrapper start={start}>
              <Img src={img} alt={alt}></Img>
            </ImgWrapper>
          </InfoColumn>
        </InfoRow>
      </Container>
    </InfoSec>
  );
}

export default landing;
